import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import LocalPrintshopRoundedIcon from "@mui/icons-material/LocalPrintshop";
import {
  Box,
  Button,
  Card,
  Container,
  Grid,
  Typography,
  Stack,
  useTheme,
  IconButton,
  Tooltip,
  Divider,
} from "@mui/material";
import {
  CheckCircle,
  CalendarDots,
  Clock,
  CurrencyInr,
  ShareNetwork,
} from "@phosphor-icons/react";
import AppLayout from "../../layouts/AppLayout";
import closeGif from "../../assets/btn_close_animated.gif";
import Footer from "../public_payment/Footer";
import { size } from "lodash";
import { useReactToPrint } from "react-to-print";
import { toBlob } from "html-to-image";
import { handleShare } from "../../libs/share/CaptureShare";
const STATUS = {
  PENDING: { text: "Pending", color: "warning" },
  SUCCESS: { text: "Success", color: "success" },
  USER_DROPPED: { text: "User dropped", color: "primary" },
  FAILED: { text: "Failed", color: "error" },
};

const formatDateTime = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  return date.toLocaleString("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
};

const Receipt = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const theme = useTheme();
  const [receiptDetails, setReceiptDetails] = useState(null);
  const settingsState = useSelector((state) => state?.settingsState);
  const [main, setMain] = React.useState();
  const componentRef = useRef();

  React.useEffect(() => {
    let mainStr = settingsState?.data?.data?.main;
    let main = typeof mainStr === "string" ? JSON.parse(mainStr) : mainStr;
    setMain(main);
    localStorage.setItem("settings", JSON.stringify(main));
  }, [settingsState]);

  const handlePrint = useReactToPrint({
    contentRef: componentRef,
    documentTitle: "Transaction Receipt",
    removeAfterPrint: true,
  });
  const handleShare = async (contentRef, type = "share") => {
    if (!contentRef?.current) return;

    try {
      const blob = await toBlob(contentRef.current);

      if (!blob) {
        console.error("Failed to create image blob");
        return;
      }

      const file = new File([blob], "receipt.png", { type: "image/png" });

      if (navigator.share && navigator.canShare({ files: [file] })) {
        await navigator.share({
          title: "Payment Receipt",
          text: "Here's your payment receipt.",
          files: [file],
        });
      } else {
        alert("Sharing not supported on this device.");
      }
    } catch (error) {
      console.error("Error sharing image:", error);
    }
  };

  const handleDownload = async () => {
    const blob = await toBlob(componentRef.current);
    if (blob) {
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "receipt.png";
      link.click();
      URL.revokeObjectURL(url);
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const encodedData = params.get("od");
    console.log("decode data",encodedData)
    if (encodedData) {
      try {
        const decodedData = JSON.parse(atob(encodedData));
        setReceiptDetails(decodedData);
        
      } catch (err) {
        console.error("Error decoding receipt data:", err);
      }
    }
  }, [location]);

  if (!receiptDetails) {
    return (
      <AppLayout>
        <Container sx={{ py: 5, textAlign: "center" }}>
          <Typography variant="h5">Loading receipt...</Typography>
        </Container>
      </AppLayout>
    );
  }

  const {
    order_id,
    loan_number,
    payment_amount,
    payment_status,
    payment_completion_time,
    plan_price,
    convenience_fee,
    payment_for,
    reciept_no,
    payment_message,
    icon,
  } = receiptDetails;

  const status = STATUS[payment_status] || {};
  const calculatedPlanPrice =
    plan_price ?? payment_amount - (convenience_fee ?? 0);
  const formattedDate = new Date(payment_completion_time);
  // console.log("receipt_no", reciept_no);
  console.log("payment_completion_time", payment_completion_time);

  return (
    <Container>
      <Box
        mb={4}
        sx={{ backgroundColor: "#f8f9fa", py: 4, minHeight: "100vh" }}
        ref={componentRef}
      >
        <Container mb={4} maxWidth="sm" sx={{}}>
          <Typography
            variant="h4"
            align="center"
            fontWeight="bold"
            sx={{ mb: 1, color: theme.palette[status.color]?.main }}
          >
            ₹{payment_amount}
          </Typography>
          <Stack spacing={1} alignItems="center" mb={2}>
            <Button
              variant="contained"
              size="small"
              sx={{ backgroundColor: theme.palette[status.color]?.main }}
            >
              {payment_status}
            </Button>

            <Typography
              variant="subtitle1"
              color={theme.palette[status.color]?.main}
              display="flex"
              alignItems="center"
              gap={1}
            >
              <CheckCircle size={20} />
              {/* {status.text} */}
            </Typography>

            <Typography variant="body2" color="text.secondary">
              {formatDateTime(payment_completion_time)}
            </Typography>
          </Stack>

          {/* Price Card */}
          <Card sx={{ p: 2, borderRadius: 3, mb: 3 }}>
            <Stack direction="row" justifyContent="space-between">
              <Typography
                variant="caption"
                display="flex"
                sx={{ mb: 1, color: "#616161" }}
              >
                Amount
              </Typography>
              <Typography fontWeight="bold">₹{payment_amount}</Typography>
            </Stack>
            <Stack
              direction="row"
              justifyContent="space-between"
              mt={1}
              color="#616161"
            >
              <Typography variant="caption">Status</Typography>
              <Typography
                variant="caption"
                color={theme.palette[status.color]?.main}
              >
                {payment_message}
              </Typography>
            </Stack>
          </Card>
          {console.log("status", payment_status)}
          {/* Details Card */}
          <Card sx={{ p: 2, borderRadius: 3, mb: 4 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={8}>
                <Typography
                  variant="caption"
                  display="flex"
                  sx={{ mb: 1, color: "#616161" }}
                >
                  <b>Order ID : {"\u00A0"} </b> {order_id}
                </Typography>
                <Typography
                  variant="caption"
                  display="flex"
                  sx={{ mb: 1, color: "#616161" }}
                >
                  <b>Loan Number : {"\u00A0"}</b> {loan_number}
                </Typography>
                <Typography
                  variant="caption"
                  display="flex"
                  sx={{ mb: 1, color: "#616161" }}
                >
                  <b>Receipt Number : {"\u00A0"}</b> {reciept_no}
                </Typography>
                <Stack
                  direction="row"
                  alignItems="center"
                  spacing={1}
                  mt={2}
                  variant="caption"
                  display="flex"
                  sx={{ mb: 1, color: "#616161" }}
                >
                  <CalendarDots size={18} />
                  <Typography variant="body2">
                    {formatDateTime(payment_completion_time)}
                  </Typography>
                  <Clock size={18} />
                  <Typography variant="body2">
                    {formattedDate.toLocaleTimeString()}
                  </Typography>
                </Stack>
              </Grid>

              <Grid
                item
                xs={12}
                md={4}
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <Stack
                  direction="row"
                  spacing={1}
                  alignItems="center"
                  color={theme.palette[status.color]?.main}
                >
                  {/* <CurrencyInr size={20} /> */}
                  {/* <Typography variant="h6" fontWeight="bold">
                    {payment_amount}
                  </Typography> */}
                </Stack>
              </Grid>
            </Grid>
          </Card>

          {/* Action Buttons */}
          <Stack spacing={2} alignItems="center">
            <img
              src={icon ? icon : main?.icon}
              style={{
                // marginTop:"2px",
                height: "50px", // Adjust height
                width: "250px", // Adjust width
                objectFit: "contain", // Maintain aspect ratio
              }}
            />
            <Stack
              direction="row"
              divider={<Divider orientation="vertical" flexItem />}
              spacing={2}
              sx={{
                "@media print": {
                  display: "none !important", // Hide button during print
                },
              }}
            >
              <div>
                <Button
                  // variant="outlined"
                  alignItems="center"
                  onClick={handlePrint}
                  sx={{
                    // border: "1px solid green",
                    width: 40, // Set width for square
                    height: 40, // Set height for square
                    "@media print": {
                      display: "none !important", // Hide button during print
                    },
                  }}
                >
                  <LocalPrintshopRoundedIcon borderRadius="0" />
                </Button>
                <Typography
                  variant="caption"
                  display="flex"
                  sx={{ mb: 1, color: "#616161" }}
                >
                  {" "}
                  🧾 PDF / Print{" "}
                </Typography>
              </div>
              <div>
                {/* <Tooltip title="Share Receipt"> */}
                  <IconButton
                    alignItems="center"
                    id="shareBtn"
                    onClick={() => {
                      handleShare(componentRef, "share");
                    }}
                    sx={{
                      //               border: "1px solid green",  // Add green border
                      borderRadius: "0%",
                      width: 40, // Set width for square
                      height: 40, // Set height for square
                      "@media print": {
                        display: "none !important", // Hide button during print
                      },
                    }}
                  >
                    <ShareNetwork size={26} />
                  </IconButton>
                {/* </Tooltip> */}
                <Typography
                  variant="caption"
                  display="flex"
                  sx={{ mb: 1, color: "#616161" }}
                >
                  Share
                </Typography>
              </div>
            </Stack>
            <Button
              variant="outlined"
              color="inherit"
              onClick={() => navigate("/history")}
              startIcon={
                <img src={closeGif} alt="Back" width={24} height={24} />
              }
              sx={{
                "@media print": {
                  display: "none !important", // Hide button during print
                },
              }}
            >
              Back
            </Button>
          </Stack>
        </Container>
      </Box>
    </Container>
  );
};

export default Receipt;
